var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { FloatingFocusManager, FloatingPortal } from "@floating-ui/react";
import { QuiMenuItemBox } from "./QuiMenuItemBox.js";
import { useQuiMenu } from "./QuiMenuContext.js";
import classNames from "classnames";
export function QuiMenuItems(_a) {
    var { children, root, className } = _a, otherProps = __rest(_a, ["children", "root", "className"]);
    const { isOpen, floatingContext, getFloatingProps, refs, floatingStyles, getItemProps, activeIndex, listRef, close } = useQuiMenu();
    return (React.createElement(FloatingPortal, { root: root }, isOpen && (React.createElement(FloatingFocusManager, { context: floatingContext, initialFocus: 1 },
        React.createElement("div", Object.assign({}, otherProps, { className: classNames("qui-menu-items", className), ref: refs.setFloating }, getFloatingProps(), { style: floatingStyles }), React.Children.map(children, (child, index) => {
            if (!React.isValidElement(child)) {
                return null;
            }
            return React.cloneElement(child, getItemProps(Object.assign(Object.assign({}, child.props), { tabIndex: activeIndex === index ? 0 : -1, role: "menuitem", ref(node) {
                    listRef.current[index] = node;
                    if (child.props.ref) {
                        child.props.ref.current = node;
                    }
                },
                onClick(event) {
                    var _a, _b;
                    if (child.type !== QuiMenuItemBox && child.props.disabled !== true) {
                        (_b = (_a = child.props).onClick) === null || _b === void 0 ? void 0 : _b.call(_a, event);
                        close();
                    }
                } })));
        }))))));
}
